module.exports = __webpack_public_path__ + "img/groups-logo.f2529144.svg";